import { render, staticRenderFns } from "./equipmentDetail.vue?vue&type=template&id=30b53126&scoped=true&"
import script from "./equipmentDetail.vue?vue&type=script&lang=js&"
export * from "./equipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./equipmentDetail.vue?vue&type=style&index=0&id=30b53126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b53126",
  null
  
)

export default component.exports